import React, { useState } from "react";
import Navigation from "../../Components/Navigation/Navigation";
import BackArrow from "../../Components/BackArrow/BackArrow";
import Search from "../../Components/Search/Search";
import modalImg from "../../Assets/Images/breed.png";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import UsersTable from "../../Components/Table/UsersTable";
import CreateModal from "../../Components/Modals/CreateModal";

const Users = () => {
  // modal
  const [modalShow, setModalShow] = useState(false);
  // search
  const [search, setSearch] = useState("");
  return (
    <div>
      <Navigation />
      <div className="User-Main">
        <BackArrow to="/activities" />
        <div className="User-Div">
          <h3>Users</h3>
          <div className="search-modal">
            <Search SearchValFuc={setSearch} SearchValue={search} />
          </div>
          <SearchBarResults SearchValue={search} />
        </div>
        <UsersTable SearchValue={search} />
      </div>
      <CreateModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        head="Add a new user"
        detail="You can add the new user here"
        placeholder="Enter user"
        images={modalImg}
      />
    </div>
  );
};

export default Users;
